import InputText from "../../../components/common/InputText/InputText";
import ConfigurationEditPage from "../../../components/management/PartnerGenericConfigurationPages/ConfigurationEditPage";
import useConfigurationForm from "../../../components/management/PartnerGenericConfigurationPages/hooks/useConfigurationForm";
import { globalOutcomeConfigValidators } from "../../../components/management/PartnerGenericConfigurationPages/validators/globalOutcomeConfigValidators";
import { paths } from "../../../routes/paths";
import "./OutcomeConfigurationEditPage.scss";

const OutcomeConfigurationEditPage = () => {
  const configKey = "global_outcomes";

  const formProps = useConfigurationForm(configKey, globalOutcomeConfigValidators);
  const { formData, fieldErrors, handleInputChange } = formProps;

  const breadcrumbPath = [
    {
      href: "/",
      label: "Home",
    },
    {
      href: `../../${paths.system_setting}`,
      label: "Program Settings",
    },
    {
      href: `../../${paths.system_setting}/${paths.global_outcomes}/edit`,
      label: "Global Outcomes Edit",
    },
  ];

  return (
    <ConfigurationEditPage
      configKey={configKey}
      configType="global outcomes"
      headerText="Global Outcomes Edit"
      description="Global configuration for the portal."
      breadcrumbPath={breadcrumbPath}
      formProps={formProps}
    >
      <InputText
        label="Points"
        placeholder="Type points"
        onChange={handleInputChange}
        className="global_outcomes-input"
        name="joy_points.points"
        value={formData.joy_points?.points || ""}
        errorMessage={fieldErrors.joy_points?.points}
        required
        type="number"
        min={0}
      />
      <InputText
        label="Limit"
        placeholder="Type limit"
        onChange={handleInputChange}
        className="global_outcomes-input"
        name="joy_points.limit"
        value={formData.joy_points?.limit || ""}
        errorMessage={fieldErrors.joy_points?.limit}
        required
        type="number"
        min={0}
      />
    </ConfigurationEditPage>
  );
};

export default OutcomeConfigurationEditPage;
